// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CheckIn from './data'

export default function CheckInFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CheckIn">
      <CheckIn {...props}>
        {children}
      </CheckIn>
    </Flow>
  )
}
